document.documentElement.classList.add('js');

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (!trigger) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = trigger.getAttribute('aria-expanded') === 'true';
  trigger.setAttribute('aria-expanded', String(!open));
  menu.hidden = open;
});

document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const price = document.querySelector('[data-product-price]');
  const button = document.querySelector('[data-add-to-cart]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
});
